const img =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE2SURBVHgBzdhtDsIgDAbgt8aD6Q/PIZ5MPYeJHyebrU6DC4O2DOKbzA+C6WNlTAX+MRdgg865TWvywJ6PgY8jOkVqSc0H1yYZkE6sX+PfnLbAAQ0zvuHweb6Smx1wH4BzNC+07MwUwTlTPOHKneCBfTS0eGdSCK4RaDqxJWYOIQ8o9YIWmBxiFrI0poTIQpbCaBBFSC1Gi1BBvBgLQg2xYqwIE0SL8SDMkBLGi3BB5jDjfYAD4YbMYOBFVEEyGDNCskJFGDEkhgc44u5IYmHGMe/Aro6kzo7a7zNrGJM7RXnNIFozgoG2M6aPRrNPeK9Naohls/JgVBDPjmnFFCE127YFQ60QVgy1RFgw1BqhxVAPhAZDvRAlDPVE5DA0Ijb4/RHeDJHBvHN7Xxvkb4kTOkUwY83wBFJXtUOHc+T9AAAAAElFTkSuQmCC';
export default img;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/images/closeRed.js